import { RECEIVE_RESOLUTION_TYPE, RESOLUTION_FORM_COMPLETED } from '../../actions/resolutions';
import {
  NAVIGATION_TO_LANDING_PAGE,
  NAVIGATION_TO_STEP_1,
  NAVIGATION_TO_STEP_2,
} from '../../actions/page';

export const initialState = {
  resolutionType: null,
  formCompleted: false,
};

export default (
  state = initialState,
  { type, data: { resolutionType, formCompleted } = {} } = {},
) => {
  switch (type) {
    case RECEIVE_RESOLUTION_TYPE:
      return {
        ...state,
        resolutionType,
      };

    case RESOLUTION_FORM_COMPLETED:
      return {
        ...state,
        formCompleted,
      };

    case NAVIGATION_TO_LANDING_PAGE:
    case NAVIGATION_TO_STEP_1:
    case NAVIGATION_TO_STEP_2:
      return { ...initialState };

    default:
      return state;
  }
};
